module.exports = __webpack_public_path__ + "static/sort-b1b645dc9b1225a5d94eff76e7471646.svg";